<template>
  <transition name="splash-fade">
    <div v-if="!finished" class="splash-wrapper">
      <div ref="splash-logo-wrapper" class="header-mask-position splash-logo-wrapper">
        <svg id="splash-logo-stroke" class="splash-logo splash-logo-stroke" viewBox="0 0 644 547" fill="none" xmlns="http://www.w3.org/2000/svg">
          <polyline stroke="white" stroke-width="1" points="472.5 1 267.01 1 451.42 321.25 459.12 308.32" />
          <polyline stroke="white" stroke-width="1" points="131.84 1.62 1.93 1.32 315.3 544.98 380.54 436.33" />
          <polyline stroke="white" stroke-width="1" points="131.84 1.62 236.02 1.85 434.45 346.55 380.54 436.33" />
          <polyline stroke="white" stroke-width="1" points="472.5 1 642.07 1 459.12 308.32" />
        </svg>
      </div>
    </div>
  </transition>
</template>

<script>
import Vivus from "vivus/dist/vivus.js";

export default {
  data() {
    return {
      finished: false,
    };
  },
  methods: {
    initVivus() {
      const self = this;

      new Vivus(
        "splash-logo-stroke",
        {
          type: "sync",
          duration: 60,
          start: "manual",
          onReady: function (vivus) {
            vivus.el.classList.add("shown");

            setTimeout(() => {
              vivus.play();
            }, 250);
          },
        },
        () => {
          if (self.$root.$refs["header-mask"]) {
            setTimeout(() => {
              self.finished = true;
              self.$root.enableScroll();

              setTimeout(() => {
                self.$emit("hidden");
              }, 350);
            }, 200);
          }
        }
      );
    },
  },
  mounted() {
    this.$root.disableScroll();

    if (document.getElementById("splash-logo-stroke")) {
      this.initVivus();
    }
  },
};
</script>

<style lang="scss">
@import "src/sass/mixins";
@import "src/sass/variables";
// @import "node_modules/bootstrap/scss/vendor/rfs";

.splash-wrapper {
  position: absolute;
  z-index: 999999;
  width: 100vw;
  height: 100vh;
  background-color: $primary;
  overflow: hidden;

  .splash-logo-wrapper {
    .splash-logo {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      transition-property: opacity;
      transition-duration: 1500ms;
      transition-timing-function: ease-in-out;

      // &.splash-logo-fill {
      //   opacity: 0;
      //   transition-duration: 500ms;

      //   &.shown {
      //     opacity: 1;
      //   }
      // }

      &.splash-logo-stroke {
        opacity: 0;
        transform: scale(calc(100% - 4px));

        &.shown {
          opacity: 1;
        }
      }
    }
  }

  // .header-mask {
  //   opacity: 0;
  //   transition-property: opacity;
  //   transition-duration: 500ms;
  //   transition-timing-function: ease-in-out;
  // }
}

.splash-fade-enter-active,
.splash-fade-leave-active {
  transition: all 500ms ease-out;
}

.splash-fade-enter-from,
.splash-fade-leave-to {
  opacity: 0;
}
</style>